<template>
	<div class="panel_shouyin">
		<!-- <div class="titleLine">
			<el-row>
				<el-col :span="2" :offset="22">
				</el-col>
			</el-row>
		</div> -->
		<div v-if="isKong" style="text-align: center;">
			<img src="../../../../assets/img/konging.png" style="width:271px;margin-top:100px;"/>
			<div style="font-size: 16px;color:#999;margin:20px;">这个人什么痕迹都没留下</div>
		</div>
		<div v-else style="margin-top:10px;">
			<div class="list">
				<div v-for="(cardItem,cardIndex) in cardList" :key="cardIndex">
					<div v-if="cardItem.type==='百天'">
						<div v-if="cardItem.status===1" class="card" @click="see(cardItem.hundred_assure)">
							<img class="cardBg" src="../../../../assets/img/mendian/baitian.png"/>
							<div class="chakanBox">
								{{cardItem.petName}}专属
							</div>
							<div class="moneyBox">
								剩余：
								{{
									$public.getIntervalDay(new Date().getTime().toString(),cardItem.expired_time)>0?
									$public.getIntervalDay(new Date().getTime().toString(),cardItem.expired_time)+'天':
									(
									$public.FAge(new Date().getTime().toString(),(Number(cardItem.expired_time)+86400))[3]&lt;0?
									0:
									$public.FAge(new Date().getTime().toString(),(Number(cardItem.expired_time)+86400))[3]
									)+'小时'
								}}
							</div>
							<div class="timeBox">有效时间：{{$public.FTime((Number(cardItem.expired_time)-8640000).toString(),'YYYY-MM-DD')}}
							至{{$public.FTime(cardItem.expired_time,'YYYY-MM-DD')}}</div>
							
						</div>
						<div v-else class="card">
							<img class="cardBg" src="../../../../assets/img/mendian/baitian0.png"/>
							<div class="chakanBox" style="color:#999999;">
								{{cardItem.petName}}专属
							</div>
							<div class="timeBox"></div>
						</div>
					</div>
					<div v-if="cardItem.type==='万元'">
						<div v-if="cardItem.status===1" class="card" @click="see(cardItem.medical_money)">
							<img class="cardBg" src="../../../../assets/img/mendian/wanyuan.png"/>
							<div class="chakanBox" style="color:#62ACFD;">
								{{cardItem.petName}}专属
							</div>
							<div class="moneyBox" style="color:#62ACFD;">金额剩余：{{cardItem.total_money}}元</div>
							<div class="timeBox" style="color:#62ACFD;">有效时间：长期有效，用完为止</div>
						</div>
						<div v-else class="card">
							<img class="cardBg" src="../../../../assets/img/mendian/wanyuan0.png"/>
							<div class="chakanBox" style="color:#999999;">
								{{cardItem.petName}}专属
							</div>
							<div class="timeBox"></div>
							<!-- <div class="moneyBox" style="color:#A4A4A4;">金额剩余：0元</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				isKong:false,
				
				cardList:[],
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
		},
		mounted(){
			let state = false;
			let list = []
			for(let i=0;i<this.userInfo.pets_info.length;i++){
				if(!this.$public.isNull(this.userInfo.pets_info[i].hundred_assure)||!this.$public.isNull(this.userInfo.pets_info[i].medical_money)){
					state = true
				}
				let pet = this.userInfo.pets_info[i];
				if(!this.$public.isNull(pet.hundred_assure)){
					list.push({
						type:'百天',
						petName:pet.nick_name,
						status:pet.hundred_assure.status,
						expired_time:pet.hundred_assure.expired_time,
						total_money:null,
						hundred_assure:pet.hundred_assure,
						medical_money:null,
					})
				}
				if(!this.$public.isNull(pet.medical_money)){
					list.push({
						type:'万元',
						petName:pet.nick_name,
						status:pet.medical_money.status,
						expired_time:null,
						total_money:pet.medical_money.total_money,
						hundred_assure:null,
						medical_money:pet.medical_money,
					})
				}
			}
			this.cardList = list;
			state===true?(this.isKong=false):(this.isKong=true);
		},
		methods: {
			see(row){
				this.$store.commit('huiyuanquanyi/set_curCard',row)
				this.$store.commit('huiyuanquanyi/set_type','seeBingli')
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:0 0 20px;box-sizing: border-box;overflow: auto;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:8px 8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
	}
	.list{
		margin:0 10px;display: flex;
		.card{
			width: 332px;height: 173px;border-radius: 14px;overflow: hidden;margin:0 auto 16px;position: relative;cursor: pointer;margin:10px 10px;
			.cardBg{
				position: absolute;top:0;right: 0;width:100%;height: 100%;;
			}
			.chakanBox{
				position: absolute;top:70px;left:23px;color:$mainColor;font-size: 16px;
				.chakanName{
					font-size: 30px;color:#32B3E1;position: absolute;padding: 14px 130px 0 0;width:100%;box-sizing: border-box;text-align: center;
				}
			}
			.moneyBox{
				position: absolute;top:110px;left:23px;color:$mainColor;font-size: 12px;
			}
			.timeBox{
				position: absolute;top:140px;left:23px;color:$mainColor;font-size: 12px;
			}
			
		}
	}
}
</style>
